export default __webpack_public_path__ + "static/media/Jang Gum.6296c64b.jpg";